<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
				<a-select  style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
									option-filter-prop="children"  :filter-option="filterOption" show-search allowClear @change="changeHandler">
					<a-select-option v-for="(item) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
				</a-select>
			<label>楼</label>
				<a-select  style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="theLou" placeholder="请选择楼"  @change="queryDYData">
				<a-select-option v-for="(item) in louList" :key="item.lou" :value="item.lou">{{item.lou}}</a-select-option>
				</a-select>
			<label>单元</label>	
				<a-select  style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="theDY" placeholder="请选择单元" >
				<a-select-option v-for="(item) in DYList" :key="item.dy" :value="item.dy">{{item.dy}}</a-select-option>
				</a-select>
			<label>付费方式</label>
			<a-select style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="dataForm.pre" placeholder="请选择付费方式" >
				<a-select-option v-for="item in preType" :key="item.pre" :value="item.pre" :label="item.pre">{{item.preName}}</a-select-option>
			</a-select>
			<label>最低金额</label>
			<a-input style="width:9rem; margin: 0 0.425rem;" v-model="louNum"/>
			<a-button size="small"  icon="search" @click="doQuery" style="margin: 0 0.425rem;">查询</a-button>
			<a-tooltip placement="topLeft" title="默认打印所有" arrow-point-at-center>
				<a-button  size="small"  @click="doPrint" style="margin: 0 0.425rem;" :disabled="isdoPrint" icon="printer">打印</a-button>
			</a-tooltip>
			<a-button  size="small" @click="exportTheList"  style="margin: 0 0.425rem;" icon="export" :loading="exportLoading">导出Excel</a-button>
			<a-button type="danger" size="small" :disabled="sending"  @click="remindCustomerAll" style="margin: 0 0.425rem;" icon="bell">提醒交费</a-button>
		</div>
		<!-- 欠费统计表格 -->
		<vxe-table  align="center" :data="oweStatisList"  border max-height="600"  :cell-style="cellClassName" ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
						 :checkbox-config="{trigger: 'row', highlight: true, range: true}"  row-id="c_id">
						<vxe-table-column type="seq" width="45"></vxe-table-column>
						<vxe-table-column type="checkbox"  width="60"></vxe-table-column>
						<vxe-table-column title="用户号" field="c_num" ></vxe-table-column>
						<vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
						<vxe-table-column title="地址" field="customerAddr" ></vxe-table-column>
						<vxe-table-column title="手机" field="CustomerMobile"></vxe-table-column>
						<vxe-table-column title="余额" field="CustomerBalance"></vxe-table-column>
						<vxe-table-column title="余额阀值" field="warnThre" ></vxe-table-column>
						<vxe-table-column title="预付费" field="prePaySign"  :formatter="getPrePaySign"></vxe-table-column>
						<vxe-table-column title="提醒次数" field="warnCount"></vxe-table-column>
						<vxe-table-column title="操作" field="c_id">
						   	<template #default="{ row }">
									<a-popconfirm title="确定要提醒此用户交费吗?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="remindCustomer(row)">
										<a-button size="small" type="link">提醒交费</a-button>
									</a-popconfirm>
						   	</template>
						   </vxe-table-column>
		</vxe-table>
	</div>
</template>

<script>

export default{
	created() {
			this.queryNeighbors();
	},
	data(){
		return{
			sending:false,
			exportLoading:false,
			isdoPrint:true,
			c_ids:[],
			neighborName:null,
			pids:[],
			print:[{
				customerNum:null,
				customerName:null,
				customerAddr:null,
				customerBalance:null,
				prePaySign:null,
				customerMobile:null,
				pid:null
			}],
			selectedNeighborList:[],
			loading:false,
			theObj:null,
			expandedRowKeys:[],
			oweStatisList:[],
			neighborList:[],
			theNeighbor:undefined,
			theLou:null,
			louList:[],
			theDY:null,
			DYList:[],
			pre:null,
			preType:[
				{
				pre:0,
				preName:'后付费'
				},
				{
				pre:1,
				preName:'预付费'
				},
				{
				pre:2,
				preName:'全部'
				},
			],
			dataForm:{
				pre:2
			},
			louNum:-0.01,
		}
	},
	methods:{
		changeHandler:function(){
			this.queryData();
			this.clearAll();
		},
		exportTheList:function(){
			if(this.theNeighbor == undefined){
				this.$message.error("请选择小区");
			}else{
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_OWE_EXPORT_URL);
				let customerIds = null;
				if(this.c_ids.length>0){
					customerIds = this.c_ids.join(",");
				}
				let param = {neighborId:this.theNeighbor.key,louId:this.theLou,dyId:this.theDY,pre:this.dataForm.pre,low:this.louNum,customerIds:customerIds};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = this.theNeighbor.label+ '-欠费统计.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			}
		},
		clearAll:function(){
			this.c_ids = [];
			this.$refs.mTable.setAllCheckboxRow(false);
		},
		scrollSome:function(){
			this.$refs.mTable.refreshScroll();
		},
		selectAllEvent ({ checked, records }) {
			if(checked){
				for(var i = 0;i<records.length;i++){
					this.c_ids.push(records[i].c_id);
				}
			}else{
				this.c_ids = [];
			}
		},
		selectChangeEvent({ checked, records }) {
			this.c_ids = [];
			for(var i = 0;i<records.length;i++){
				this.c_ids.push(records[i].c_id);
			}
		},
		cellClassName({ row, rowIndex, column }){
			let style = null;
			if(column.property == 'CustomerBalance'){
				if(row.CustomerBalance<=0){
					 style =  {
						 backgroundColor: '#ffee00',
						 color: '#ff0000'
					 }
				}
			}else{
				style = {
						'color':'#000',
				}	
			}	
			return style;
		},
		getPrePaySign({cellValue}){
			return this.Config.getValueByNameFromList(cellValue,this.Config.getPrepaySignList());
		},
		doPrint:function(){
			this.neighborName=this.theNeighbor.label;
			let userId = this.Config.getUserLocal().pId;
			let url = this.Api.getLastUrl('/report/oweReport');
			if(this.c_ids.length == 0){
				for(var i = 0;i<this.oweStatisList.length;i++){
					let item = this.oweStatisList[i];
					this.c_ids.push(item.c_id);
				}
			}
			let pidsStr=this.c_ids.join("-");
			window.open(url+'?userId='+userId+"&neighbor="+this.neighborName+"&pidsStr="+pidsStr, "_blank");
			//this.clearAll();
		},
		remindCustomerAll:function(){
			if(this.c_ids.length == 0){
				this.$message.error("请选择要提醒的用户");
			}else{
				this.sending = true;
				this.neighborName=this.theNeighbor.label;
				let cid=this.c_ids.join("-");
				let userId = this.Config.getUserLocal().pId;
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_SENDSMS_REMIND_URL);
				let param = {cids:cid,userId:userId,neighborName:this.neighborName};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					//this.clearAll();
					this.sending = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					//this.clearAll();
					this.sending = false;
					console.log(error);
				});
			}
		},
		remindCustomer:function(record){
			this.c_ids = [];
			this.neighborName=this.theNeighbor.label;
			if(record.c_id!=undefined || record.c_id>0){
				this.c_ids.push(record.c_id);
			}
			let userId = this.Config.getUserLocal().pId;
			let url = this.Api.getLastUrl(this.Api.CUSTOMER_SENDSMS_REMIND_URL);
			let cid=this.c_ids.join("-");
			let param = {cids:cid,userId:userId,neighborName:this.neighborName};
			this.Api.fetchPostWithForm(url,param).then((data)=>{
				//this.clearAll();
				let code = data.data.code;
				let result = data.data.result;
				let msg = data.data.message;
				if(code == this.Api.HTTP_OK_CODE){
					this.$message.success(result);
				}else{
					this.$message.error(msg);
				}
			}).catch((error)=>{
				//this.clearAll();
				console.log(error);
			});
		},
		queryDYList:function(){
			let url = this.Api.getLastUrl(this.Api.NEIGHBOR_LIST_DY_URL);
			let param = {neighborId:this.theNeighbor.key,louId:this.theLou};
			this.Api.fetchPostWithForm(url,param).then((data)=>{
				let code = data.data.code;
				let result = data.data.result;
				let msg = data.data.message;
				if(code == this.Api.HTTP_OK_CODE){
					this.DYList = result;
				}else{
					this.$message.error(msg);
				}
			}).catch((error)=>{
				console.log(error);
			});
		},
		queryLouList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_LIST_LOU_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.louList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		queryDYData:function(){
			this.theDY = null;
			this.queryDYList();
		},
		queryData:function(){
				this.selectedRowKeys = [];
				this.theLou = null;
				this.doQuery();
				this.queryLouList();
			},
		queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		doQuery:function(){
			this.isdoPrint=true;
			this.oweStatisList = [];
				if(this.theNeighbor !=null && this.theNeighbor!=undefined){
					this.loading = true;
					let url = this.Api.getLastUrl(this.Api.Static_LIST_OWE_URL);
					let param = {neighborId:this.theNeighbor.key,louId:this.theLou,dyId:this.theDY,pre:this.dataForm.pre,low:this.louNum};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.oweStatisList = result;
							this.isdoPrint=false;
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(error);
						this.loading = false;
					});
				}else{
					this.$message.error('请选择小区');
				}
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
}

	
	}
</script>

<style>
</style>
